export default __webpack_public_path__ + "static/media/fog.d3e16ce0.svg";